import { SkeletonProps } from './Skeleton.types';

export const getBorderRadius = (variant: SkeletonProps['variant']) => {
  switch (variant) {
    case 'rounded':
      return '8px';
    case 'circle':
      return '100%';
    case 'square':
    default: {
      return 0;
    }
  }
};
